class Menus {
    constructor() {
        this.init();
    }

    init() {
        this.menuBar();
        this.megaMenu();
    }

    menuBar() {
        $('.js-menu-bar-open').on('click', () => {
            $('.menu-bar__content').addClass('active');
        });
        $('.js-menu-bar-close').on('click', () => {
            $('.menu-bar__content').removeClass('active');
        });
    }

    megaMenu() {
        $('.mega-menu-close').on('click', e => {
            let $_ = $(e.delegateTarget);
            $_.closest('.mega-menu').removeClass('mega-menu--active');
            $('html').removeClass('mega-menu-is-active compensate-for-scrollbar-padding');
            $('.select-a-company, .footer__bar').removeClass('compensate-for-scrollbar-position');
        });

        $('[data-go-menu-id]').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            let $_ = $(e.delegateTarget);
            let id = $_.attr('data-go-menu-id');
            let targetMenu = $('[data-menu-id="' + id + '"]');

            // close if click once again
            if (targetMenu.hasClass('mega-menu--active')) {
                targetMenu.find('.mega-menu-close').trigger('click');
                return false;
            }

            // show current
            $('.mega-menu').not(targetMenu).removeClass('mega-menu--active');
            targetMenu.addClass('mega-menu--active');
            $('html').addClass('mega-menu-is-active compensate-for-scrollbar-padding');
            $('.select-a-company, .footer__bar').addClass('compensate-for-scrollbar-position');
        });

        $(document).on('keyup', e => {
            const $megamenu = $('.mega-menu--active')
            if (e.keyCode === 27 && $megamenu.length) {
                $megamenu.each((index, element) => {
                    $(element).find('.mega-menu-close').trigger('click');
                });
            }
        });
    }
}

export default Menus;



// WEBPACK FOOTER //
// ./src/assets/js/components/Menus.js